// Country name -> ISO2 mapping for real flag rendering via flagcdn.com.
// Only confident mappings are included; unknowns fall back to a monogram.

const NAME_TO_ISO: Record<string, string> = {
  "turkey": "tr", "türkiye": "tr", "turkiye": "tr",
  "england": "gb-eng", "scotland": "gb-sct", "wales": "gb-wls", "northern ireland": "gb-nir",
  "united kingdom": "gb", "great britain": "gb",
  "italy": "it", "spain": "es", "germany": "de", "france": "fr", "portugal": "pt",
  "netherlands": "nl", "belgium": "be", "brazil": "br", "argentina": "ar", "colombia": "co",
  "chile": "cl", "uruguay": "uy", "peru": "pe", "ecuador": "ec", "paraguay": "py", "bolivia": "bo",
  "venezuela": "ve", "mexico": "mx", "usa": "us", "united states": "us", "canada": "ca",
  "ireland": "ie", "switzerland": "ch", "austria": "at", "poland": "pl", "denmark": "dk",
  "sweden": "se", "norway": "no", "finland": "fi", "iceland": "is", "greece": "gr",
  "croatia": "hr", "serbia": "rs", "slovenia": "si", "slovakia": "sk", "czech republic": "cz",
  "czechia": "cz", "hungary": "hu", "romania": "ro", "bulgaria": "bg", "ukraine": "ua",
  "russia": "ru", "belarus": "by", "georgia": "ge", "armenia": "am", "azerbaijan": "az",
  "japan": "jp", "south korea": "kr", "korea republic": "kr", "china": "cn", "australia": "au",
  "saudi arabia": "sa", "qatar": "qa", "uae": "ae", "united arab emirates": "ae", "egypt": "eg",
  "morocco": "ma", "algeria": "dz", "tunisia": "tn", "nigeria": "ng", "ghana": "gh",
  "south africa": "za", "cameroon": "cm", "senegal": "sn", "ivory coast": "ci",
  "israel": "il", "cyprus": "cy", "malta": "mt", "luxembourg": "lu", "albania": "al",
  "north macedonia": "mk", "fyr macedonia": "mk", "f.y.r. macedonia": "mk", "macedonia": "mk",
  "san marino": "sm", "andorra": "ad", "faroe islands": "fo", "gibraltar": "gi", "liechtenstein": "li",
  "bosnia and herzegovina": "ba", "montenegro": "me", "kosovo": "xk",
  "estonia": "ee", "latvia": "lv", "lithuania": "lt", "moldova": "md", "kazakhstan": "kz",
  "india": "in", "indonesia": "id", "thailand": "th", "vietnam": "vn", "malaysia": "my",
  "new zealand": "nz", "costa rica": "cr", "panama": "pa", "honduras": "hn", "guatemala": "gt",
  "el salvador": "sv", "jamaica": "jm", "iran": "ir", "iraq": "iq", "jordan": "jo",
};

export function countryFlagUrl(country: string | null | undefined): string | null {
  if (!country) return null;
  const iso = NAME_TO_ISO[country.trim().toLowerCase()];
  if (!iso) return null;
  return `https://flagcdn.com/w40/${iso}.png`;
}
